var initialState = {
  newInvoicesettings: [],
  printerName: "",
  tempState: false,
};

const InvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INVOICE-NEWBILLSETTINGS": {
      return {
        ...state,
        tempState: false,
        newInvoicesettings: action.payload,
      };
    }

    case "INVOICE-NEWBILLSETTINGS-TEMP": {
      return {
        ...state,
        tempState: true,
        newInvoicesettings: action.payload,
      };
    }

    case "INVOICE-NEWBILLSETTINGS_UPDATE":
      console.log("testsdsdsd1212", action.payload);
      return {
        ...state,
        tempState: false,
        newInvoicesettings: {
          ...state.newInvoicesettings,
          ...action.payload,
        },
      };
    case "UPDATE_INVOICE_NUMBER":
      return {
        ...state,
        tempState: false,
        newInvoicesettings: {
          ...state.newInvoicesettings,
          currentInvoiceNumber: action.payload,
        },
      };
    default:
      return state;
  }
};

export default InvoiceReducer;
